export const Endpoint = process.env.REACT_APP_API_URL;

export const Constants = {
  API_DASHBOARD: `${Endpoint}/dashboard`,
  GET_DATA: 'GET_DATA',
  GET_FAILURE: 'GET_FAILURE',
};
